/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Poisson distribution quantile function.
*
* @module @stdlib/stats/base/dists/poisson/quantile
*
* @example
* import quantile from '@stdlib/stats/base/dists/poisson/quantile';
*
* var y = quantile( 0.5, 2.0 );
* // returns 2
*
* y = quantile( 0.9, 4.0 );
* // returns 7
*
* y = quantile( 0.1, 200.0 );
* // returns 182
*
* var myquantile = quantile.factory( 5.0 );
* y = myquantile( 0.4 );
* // returns 4
*
* y = myquantile( 0.8 );
* // returns 7
*
* y = myquantile( 1.0 );
* // returns Infinity
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-nonenumerable-read-only-property';
import main from './main.js';
import factory from './factory.js';


// MAIN //

setReadOnly( main, 'factory', factory );


// EXPORTS //

export default main;
